import { ComponentStyleConfig, theme as chakraTheme } from '@chakra-ui/theme'

const { baseStyle } = chakraTheme.components.Tag
export const Tag: ComponentStyleConfig = {
  defaultProps: {
    variant: 'chip-outline',
  },
  variants: {
    'chip-outline': ({ isDisabled, onClick }) => ({
      closeButton: {
        ...baseStyle.closeButton,
        _active:
          !isDisabled && onClick
            ? {
                backgroundColor: 'neutral.40',
                borderColor: 'transparent',
                color: 'deepPurple',
              }
            : undefined,
        _disabled: {
          color: 'neutral.30',
          cursor: 'default',
          opacity: 1,
          pointerEvents: 'none',
        },
        _focus:
          !isDisabled && onClick
            ? {
                backgroundColor: 'neutral.30',
                borderColor: 'white',
                boxShadow: 'unset',
                color: 'deepPurple',
              }
            : undefined,
        _hover: {
          opacity: 1,
        },
        borderRadius: '50%',
        color: 'currentColor',
        cursor: 'pointer',
        opacity: 1,
      },
      container: {
        ...baseStyle.container,
        _hover:
          !isDisabled && onClick
            ? {
                backgroundColor: 'neutral.30',
                borderColor: 'transparent',
                color: 'deepPurple',
              }
            : undefined,
        backgroundColor: 'white',
        border: `1px solid`,
        borderColor: !isDisabled ? 'neutral.60' : 'neutral.30',
        borderRadius: 'full',
        color: !isDisabled ? 'neutral.50' : 'neutral.30',
      },
      label: {
        ...baseStyle.label,
        lineHeight: '0.9',
      },
    }),
    'chip-solid': ({ colorScheme, isDisabled, onClick }) => ({
      closeButton: {
        ...baseStyle.closeButton,
        _active:
          !isDisabled && onClick
            ? {
                backgroundColor:
                  colorScheme !== 'neutral'
                    ? `${colorScheme}.60`
                    : 'neutral.80',
              }
            : undefined,
        _disabled: {
          color: 'white',
          cursor: 'default',
          opacity: 1,
          pointerEvents: 'none',
        },
        _focus:
          !isDisabled && onClick
            ? {
                borderColor: 'white',
                boxShadow: 'unset',
              }
            : undefined,
        _hover: {
          opacity: 1,
        },
        borderRadius: '50%',
        color: 'white',
        cursor: 'pointer',
        opacity: 1,
      },
      container: {
        ...baseStyle.container,
        _hover:
          !isDisabled && onClick
            ? {
                backgroundColor:
                  colorScheme !== 'neutral'
                    ? `${colorScheme}.40`
                    : 'neutral.60',
              }
            : undefined,
        backgroundColor: isDisabled
          ? 'neutral.30'
          : colorScheme !== 'neutral'
          ? `${colorScheme}.50`
          : 'deepPurple',
        border: 'none',
        borderRadius: 'full',
        outline: 'none',
      },
      label: {
        ...baseStyle.label,
        color: 'white',
        lineHeight: '0.9',
      },
    }),
    'tag-outline': ({ colorScheme }) => ({
      closeButton: {
        display: 'none',
      },
      container: {
        ...baseStyle.container,
        backgroundColor: 'transparent',
        border: '1px solid #FFCB64',
        borderRadius: 'unset',
        color: '#481A00',
        minW: 12,
        p: 1,
      },
      label: {
        ...baseStyle.label,
        color: colorScheme !== 'neutral' ? `${colorScheme}.70` : 'deepPurple',
        lineHeight: '0.9',
      },
    }),
    'tag-shade': ({ colorScheme }) => ({
      closeButton: {
        display: 'none',
      },
      container: {
        ...baseStyle.container,
        backgroundColor:
          colorScheme !== 'neutral' ? `${colorScheme}.10` : 'neutral.10',
        borderRadius: 'unset',
      },
      label: {
        ...baseStyle.label,
        color: colorScheme !== 'neutral' ? `${colorScheme}.70` : 'deepPurple',
        lineHeight: '0.9',
      },
    }),
    'tag-solid': ({ colorScheme }) => ({
      closeButton: {
        display: 'none',
      },
      container: {
        ...baseStyle.container,
        backgroundColor:
          colorScheme !== 'neutral' ? `${colorScheme}.70` : 'deepPurple',
        border: 'none',
        borderRadius: 'unset',
      },
      label: {
        ...baseStyle.label,
        color: 'white',
        lineHeight: '0.9',
      },
    }),
  },
}
